import { useTranslation } from 'react-i18next';

import { Button, Tooltip } from '@treezor/design-system';

import { useKycInfos } from '../../hooks/useKycInfos';

import { useAccesControl } from '@/hooks/useAccessControl';
import { useAction } from '@/hooks/useAction';
import { useConfirmationDialog } from '@/hooks/useConfirmationModal';

import { featuresSlugs } from '@/features/roles/store/models/features.model';

export const UserKYCReview = () => {
  const { t } = useTranslation();
  const {
    pageTitle,
    isKycActionDisabled: isDisabled,
    isUserStatusNotOkToSubmitKyc,
    hasDocumentToReview,
    handleReviewKyc,
    isSubmitKycLoading,
    isKycDocLoading,
  } = useKycInfos();
  const { displayActionFromConfig } = useAction();
  const { hasAccessToFeature } = useAccesControl();

  const KycReviewDocumentsConfirmationModal = useConfirmationDialog({
    title: t('pages.currentProfiles.actionUser.addWallet.kyc.review.title'),
    highlight: t('pages.currentProfiles.actionUser.addWallet.kyc.review.description'),
    description: t('pages.currentProfiles.actionUser.addWallet.kyc.review.subDescription'),
    confirm: {
      label: t('pages.currentProfiles.actionUser.addWallet.kyc.review.yes'),
      action: handleReviewKyc,
      color: 'success',
    },
  });

  const toggleKycReviewDocumentsConfirmationModal = () => KycReviewDocumentsConfirmationModal.toggle();

  return (
    <div className="flex items-center">
      {displayActionFromConfig('reviewKyc') && hasAccessToFeature(featuresSlugs.SUBMIT_KYC) && (
        <>
          {isUserStatusNotOkToSubmitKyc || hasDocumentToReview ? (
            <Tooltip
              messageContent={
                isUserStatusNotOkToSubmitKyc
                  ? t('pages.currentProfiles.kyc.actions.submitKycDisabledReason.userStatus', { value: pageTitle })
                  : t('pages.currentProfiles.kyc.actions.submitKycDisabledReason.unreviewedDoc')
              }
              contentClassName="min-w-[200px]"
              placement="bottom"
            >
              <Button id="User-kyc-review-request-btn" variant="tertiary" disabled>
                {t('pages.currentProfiles.kyc.actions.submitKyc', { value: pageTitle })}
              </Button>
            </Tooltip>
          ) : (
            <Button
              id="User-kyc-review-request-btn"
              variant="tertiary"
              onClick={toggleKycReviewDocumentsConfirmationModal}
              isLoading={isSubmitKycLoading}
              disabled={isDisabled || isKycDocLoading}
            >
              {t('pages.currentProfiles.kyc.actions.submitKyc', { value: pageTitle })}
            </Button>
          )}
        </>
      )}

      <KycReviewDocumentsConfirmationModal.ConfirmationDialog />
    </div>
  );
};
